import { ChangeDetectionStrategy, Component } from '@angular/core'
import { TranslatePipe } from '@ngx-translate/core'

type MinutesSkeletonItem = { titleWidth: string; paragraphs: string[][]; bullets: string[] }

/** Stands in for the minutes while they generate, shaped like the finished document. */
@Component({
  selector: 'app-minutes-skeleton',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './minutes-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './minutes-skeleton.component.scss',
})
export class MinutesSkeletonComponent {
  readonly items: MinutesSkeletonItem[] = [
    { titleWidth: '34%', paragraphs: [['100%', '97%', '58%']], bullets: [] },
    {
      titleWidth: '42%',
      paragraphs: [
        ['100%', '94%', '99%', '41%'],
        ['88%', '52%'],
      ],
      bullets: ['64%', '48%'],
    },
    { titleWidth: '28%', paragraphs: [['100%', '72%']], bullets: ['56%'] },
    { titleWidth: '38%', paragraphs: [['100%', '96%', '64%']], bullets: [] },
  ]
}
